(function () {
  const STORAGE_KEY = 'spec-weight-unit';
  const KG_TO_LBS = 2.20462;

  function parseKg(str) {
    if (!str) return null;
    const match = String(str).match(/([\d.,]+)/);
    if (!match) return null;
    return parseFloat(match[1].replace(',', '.'));
  }

  function formatWeight(kgStr, unit) {
    const kg = parseKg(kgStr);
    if (kg === null) return kgStr ?? '—';
    if (unit === 'lbs') return (kg * KG_TO_LBS).toFixed(2) + ' lbs';
    return kg + ' kg';
  }

  function applyUnit(unit) {
    document.querySelectorAll('.spec-weight').forEach((cell) => {
      cell.textContent = formatWeight(cell.dataset.kg, unit);
    });

    document.querySelectorAll('.spec-unit-btn').forEach((btn) => {
      btn.classList.toggle('active', btn.dataset.unit === unit);
    });

    localStorage.setItem(STORAGE_KEY, unit);
  }

  function init() {
    const savedUnit = localStorage.getItem(STORAGE_KEY) || 'kg';
    applyUnit(savedUnit);

    document.querySelectorAll('.spec-unit-btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        const current = localStorage.getItem(STORAGE_KEY) || 'kg';
        applyUnit(current === 'kg' ? 'lbs' : 'kg');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();